import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { groupBy, mapValues, round, sumBy } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { UpdateCapitalActionFormValues } from 'routes/LpPages/CapitalActions/AddEditCapitalAction/hooks/useCapitalActionForm';

export default function useRecallableDistributionCalledInOtherEntries(
  entryIndex: number,
) {
  const { watch } = useFormContext<UpdateCapitalActionFormValues>();

  const entries = watch('entries') ?? [];

  const recallableDistributionCalledInOtherEntries = mapValues(
    groupBy(
      entries
        .filter(
          (entry, index) =>
            index !== entryIndex &&
            [
              CapitalActionEntryType.GeneralCapitalCall,
              CapitalActionEntryType.Expense,
              CapitalActionEntryType.Investment,
            ].includes(entry.entryType),
        )
        .map((entry) => entry.capitalBreakdown ?? [])
        .flat(),
      (breakdownEntry) => breakdownEntry.commitmentId,
    ),
    (breakdownEntries) =>
      round(
        sumBy(
          breakdownEntries,
          (breakdownEntry) =>
            breakdownEntry.fundsCalled?.fromRecallableDistributionLcy ?? 0,
        ),
        3,
      ),
  );

  return Object.keys(recallableDistributionCalledInOtherEntries).map(
    (commitmentId) => ({
      commitmentId,
      calledAmountLcy: recallableDistributionCalledInOtherEntries[commitmentId],
    }),
  );
}
